<template>
    <div :id="'listingID_' + component.id" :class="[ 'listing-item', { 'compact': compact } ]">
        <router-link class="view-listing" :data-id="component.id" :to="component.listingURL.toLowerCase().replace(',', '').replaceAll(' ', '-')" @click="setRoute( component.listingURL.toLowerCase().replace(',', '').replaceAll(' ', '-') )"></router-link>
        <div class="img-parent" :style="{ 'background-image': 'url(' + component.image + ')' }"></div>
        <div class="d-flex justify-content-between align-items-end listing-content">
            <div class="panel">
                <div class="row d-flex align-items-end justify-content-between h-100">
                    <div class="col-12">
                        <h3 class="listing-suburb text-start">{{ component.address.suburb }}</h3>
                        <h5 v-if="component.address.lot" class="listing-address text-start"><small>{{ component.address.lot }}</small></h5>
                        <h5 v-else class="listing-address text-start"><small>{{ component.address.number }} {{ component.address.street }}</small></h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    
    export default({
        name: "listing component",
        props: {
            image:      { default: null },
            suburb:     { default: null },
            street:     { default: null },
            number:     { default: null },
            listingURL: { default: null },
            id:         { default: null },
            lot:        { default: null },
            // tightens the card for the 4-up "similar listings" row
            compact:    { type: Boolean, default: false }
        },
        data() {
            return {
                component: {
                    id:     this.id,
                    image: this.image,
                    listingURL: this.listingURL,
                    address: {
                        lot:    this.lot,
                        suburb: this.suburb,
                        street: this.street,
                        number: this.number
                    },
                }
            }
        },
        methods: {
            setRoute( link ) {

                // Set session data
                let listingParent = this.component.id;

                sessionStorage.setItem( "listingID", this.component.id );
                document.cookie = ( 'listingID=' + this.component.id );

                // set route
                this.$router.push(link);
            }
        }
    });
</script>

<style lang="scss" scoped>

    // global vars
    @import "../../scss/vars.one3design.scss";

    // global mixins
    @import "../../scss/mixins.one3design.scss";

    // component styles
    .listing-item {
        background-color:$color_base;
        cursor:pointer;
        margin-bottom:2em;
        min-height:1px;
        padding-bottom:100%;
        position:relative;
        width:100%;
        .view-listing {
            bottom:0;
            left:0;
            position:absolute;
            right:0;
            top:0;
            z-index:+1;
        }
        .img-parent {
            @include images( center, cover );
            bottom:0;
            left:0;
            position:absolute;
            right:0;
            top:0;
        }
        .listing-content {
            bottom:0;
            left:0;
            padding:2em;
            position:absolute;
            right:0;
            top:0;
            .panel {
                background-color:$black;
                border-top: 6px solid $color_main;
                height:150px;
                padding:1em;
                position:relative;
                width:100%;
                .listing-suburb {
                    color:$color_main;
                    font-weight:$font-weight-bold;
                    letter-spacing: .025em;
                    margin:0 0 .15em;
                }

                .listing-address {
                    color:$white;
                    font-weight:$font-weight-light;
                    letter-spacing: .025em;
                    margin:0;
                }

            }
        }

        @media screen and ( max-width:$mobile) {
             .listing-content {
                padding:0;
                 .panel {
                    height:100px;
                    .listing-suburb {
                        font-weight:1.2em !important;
                    }
                }
            }
        }
        // 4-up row on the listing detail page - smaller card, lighter panel
        &.compact {
            margin-bottom:1.5em;
            overflow:hidden;
            padding-bottom:75%;
            .img-parent {
                @include animation(transform, .35s, ease-out);
            }
            .listing-content {
                padding:1em;
                .panel {
                    border-top:4px solid $color_main;
                    height:auto;
                    padding:.75em 1em;
                    .listing-suburb {
                        font-size:1.25em;
                    }
                    .listing-address {
                        font-size:.9em;
                        small {
                            font-size:100%;
                        }
                    }
                }
            }
            &:hover {
                .img-parent {
                    -webkit-transform:scale(1.05);
                    -moz-transform:scale(1.05);
                    -o-transform:scale(1.05);
                    transform:scale(1.05);
                }
            }
            @media screen and ( max-width:$mobile) {
                padding-bottom:66%;
                .listing-content {
                    padding:1em;
                    .panel {
                        height:auto;
                    }
                }
            }
        }
        /*
        &#listingID_3570684, &#listingID_3595209 {
            display:none;
        }
        */
    }
</style>